import {app} from "../firebase";
import {getDatabase,ref,get,set,push,child,remove,update} from "firebase/database"

function getFixedCustsCollectionByCompany(companyId) {
  return `companies/${companyId}/fixedCosts`;
}

export const saveFixedCust = async (companyId, data) => {
  const db = getDatabase(app);
  if (!companyId) {
    throw new Error("Nenhum ID de empresa fornecido.");
  }
  const cleanData = removeUndefined(data);
  const newFixedCustRef = push(ref(db, getFixedCustsCollectionByCompany(companyId)));
  const newFixedCustId = newFixedCustRef.key;
  await set(newFixedCustRef, cleanData);

  return { id: newFixedCustId, ...cleanData };
};

function removeUndefined(obj) {
  return JSON.parse(JSON.stringify(obj));
}

export const deleteFixedCust = async (companyId, FixedCustId) => {
  if (!companyId || !FixedCustId) throw new Error("IDs inválidos para exclusão");
  const db = getDatabase(app);

  await remove(ref(db, `${getFixedCustsCollectionByCompany(companyId)}/${FixedCustId}`));
};

export const updateFixedCust = async (companyId, FixedCustId, data) => {
  if (!companyId || !FixedCustId) throw new Error("IDs inválidos");
  const db = getDatabase(app);
  const cleanData = removeUndefined(data);
  await update(ref(db, `${getFixedCustsCollectionByCompany(companyId)}/${FixedCustId}`), cleanData);
  return { id: FixedCustId, ...cleanData };
};

export const getFixedCusts = async (companyId) => {
  const db = getDatabase(app);
  if (!companyId) throw new Error("Nenhum ID de empresa fornecido.");

  const dbRef = ref(db);
  const snapshot = await get(child(dbRef, getFixedCustsCollectionByCompany(companyId)));

  if (snapshot.exists()) {
    const data = snapshot.val();
    return Object.entries(data).map(([id, value]) => ({
      id,
      ...value,
    }));
  } else {
    return [];
  }
};


